import { useLocation } from "react-router";

/**
 * Set on links back to the login page from an MCP sign-up, so the login route knows the
 * visitor chose it rather than being sent there by the connector — without it the two
 * pages redirect at each other forever.
 */
export const SIGN_IN_PARAM = "signin";
export const SIGN_IN_QUERY = { [SIGN_IN_PARAM]: "true" };

const useQueryParams = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const provider = searchParams.get("provider") || searchParams.get("segment");
  const disableProviderSwitching = searchParams.get("disableProviderSwitching") === "true";
  const redirect = searchParams.get("r");
  const isFromMCP = searchParams.get("mcp") === "true";
  const wantsSignIn = searchParams.get(SIGN_IN_PARAM) === "true";
  const email = searchParams.get("email") || searchParams.get("e");
  const emailCode = searchParams.get("emailCode");
  const state = searchParams.get("state");
  const callbackUrl = searchParams.get("callback_url");
  const inviteCode = searchParams.get("inviteCode");
  const referrerCode = searchParams.get("referrerCode");
  const partner = searchParams.get("p");
  const userType = searchParams.get("userType");
  return {
    provider,
    disableProviderSwitching,
    redirect,
    isFromMCP,
    wantsSignIn,
    email,
    emailCode,
    state,
    callbackUrl,
    inviteCode,
    referrerCode,
    partner,
    userType,
  };
};

export default useQueryParams;
